import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cache: {} // { [key]: { data, timestamp } }
};

const cacheSlice = createSlice({
  name: "cache",
  initialState,
  reducers: {
    setCache(state, action) {
      const { key, data } = action.payload;
      const [baseKey] = key.split(":");

      // Remove other entries with same baseKey
      Object.keys(state.cache).forEach(k => {
        if (k.startsWith(`${baseKey}:`) && k !== key) {
          delete state.cache[k];
        }
      });

      state.cache[key] = {
        data,
        timestamp: Date.now()
      };
    },
    clearCache(state, action) {
      delete state.cache[action.payload.key];
    },
    clearAllCacheForBaseKey(state, action) {
      const baseKey = action.payload.baseKey;
      Object.keys(state.cache).forEach(key => {
        if (key.startsWith(`${baseKey}:`)) {
          delete state.cache[key];
        }
      });
    },
    // clear everything
    clearAllCache(state) {
      state.cache = {};
    }
  }
});

export const { setCache, clearCache, clearAllCacheForBaseKey, clearAllCache } = cacheSlice.actions;
export default cacheSlice.reducer;